<template>
    <b-modal title="Retaining Style Section"
             size="sm"
             class="font-weight-bold"
             centered
             no-close-on-backdrop
             v-model="dialogOpen"
             @hidden="onDialogHidden">
        <!--this binds the enter key to the insert event, i.e. makes the OK button the default button-->
        <vue-keypress key-event="keydown" :key-code="13" @success="handleEnterKey"></vue-keypress>

        <vue-keypress key-event="keydown" :key-code="66" :modifiers="['altKey']" :preventDefault="true" @success="pageBreakBefore = !pageBreakBefore"></vue-keypress>
        <vue-keypress key-event="keydown" :key-code="65" :modifiers="['altKey']" :preventDefault="true" @success="pageBreakAfter = !pageBreakAfter"></vue-keypress>
        <vue-keypress key-event="keydown" :key-code="73" :modifiers="['altKey']" :preventDefault="true" @success="indented = !indented"></vue-keypress>

        <b-alert v-model="showErrors" variant="danger" dismissible>
            <div v-for="(error, index) in currentErrors" :key="index">
                <p>{{ error }}</p>
            </div>
        </b-alert>
        <div ref="inputFields">
            <b-form-group label-cols
                          content-cols="4"
                          content-cols-md="3"
                          content-cols-lg="2"
                          label="Page break before (Alt+B)"
                          label-for="pageBreakBefore"
                          class="mb-0">
                <b-form-checkbox name="pageBreakBefore" v-model="pageBreakBefore" switch class="pt-2"></b-form-checkbox>
            </b-form-group>
            <b-form-group label-cols
                          content-cols="4"
                          content-cols-md="3"
                          content-cols-lg="2"
                          label="Page break after (Alt+A)"
                          label-for="pageBreakAfter"
                          class="mb-0">
                <b-form-checkbox name="pageBreakAfter" v-model="pageBreakAfter" switch class="pt-2"></b-form-checkbox>
            </b-form-group>
            <b-form-group label-cols
                          content-cols="5"
                          content-cols-md="4"
                          content-cols-lg="3"
                          label="Empty lines before"
                          label-for="emptyLinesBefore"
                          class="mb-1">
                <b-form-input name="emptyLinesBefore" type="number" min="0" max="5" v-model="emptyLinesBefore" autofocus/>
            </b-form-group>
            <b-form-group label-cols
                          content-cols="5"
                          content-cols-md="4"
                          content-cols-lg="3"
                          label="Empty lines after"
                          label-for="emptyLinesAfter"
                          class="mb-1">
                <b-form-input name="emptyLinesAfter" type="number" min="0" max="5" v-model="emptyLinesAfter" />
            </b-form-group>
            <b-form-group label-cols
                          content-cols="4"
                          content-cols-md="3"
                          content-cols-lg="2"
                          label="Indented (Alt+I)"
                          label-for="indented"
                          class="mb-0">
                <b-form-checkbox name="indented" v-model="indented" switch class="pt-2"></b-form-checkbox>
            </b-form-group>
        </div>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="danger" @click="reset">Reset</b-button>
            <b-button @click="cancel">Cancel</b-button>
            <b-button variant="success" @click="insert">OK</b-button>
        </template>
    </b-modal>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import VueKeypress from 'vue-keypress';
    import { v4 as newUuid } from 'uuid';

    import InputMixin from '../../mixins/InputMixin';
    import EventsMixin from '../../mixins/EventsMixin';

    Vue.use(BootstrapVue);

    export default {
        name: 'TopscribeRetainingStyleDialog',
        mixins: [InputMixin, EventsMixin],
        components: {
            'vue-keypress': VueKeypress
        },
        model: {
            event: 'change',
            prop: 'active'
        },
        props: {
            active: {
                type: Boolean,
                default: false
            },
            mode: {
                type: String,
                default: 'insert',
                validator: function (value) {
                    // The value must match one of these strings
                    return (['insert', 'edit'].indexOf(value) !== -1);
                }
            },
            currentEditorSection: {
                default: null
            }
        },
        data: function () {
            return {
                dialogOpen: this.active,
                currentErrors: null,
                showErrors: false,

                pageBreakBefore: false,
                pageBreakAfter: false,
                emptyLinesBefore: 0,
                emptyLinesAfter: 0,
                indented: false,

                sectionId: null,
                sectionsInsertedEventData: null,
                sectionUpdated: false
            }
        },
        watch: {
            active: function () {
                if (this.active) {
                    //the dialog is about to open
                    this.currentErrors = null;
                    if (this.mode == 'edit') {
                        try {
                            var base64EncodedMetaData = $(this.currentEditorSection).data('metadata');
                            var metaData = JSON.parse(atob(base64EncodedMetaData));
                            this.sectionId = metaData.SectionId;
                            this.pageBreakBefore = metaData.PageBreakBefore;
                            this.pageBreakAfter = metaData.PageBreakAfter;
                            this.emptyLinesBefore = metaData.EmptyLinesBefore;
                            this.emptyLinesAfter = metaData.EmptyLinesAfter;
                            this.indented = metaData.Indented;
                        }
                        catch
                        {
                            console.warn('invalid metadata in section');
                        }
                    } else {
                        this.sectionId = null;
                        this.reset();
                    }
                    this.sectionsInsertedEventData = null;
                    this.sectionUpdated = false;
                }
                this.dialogOpen = this.active;
            },
            currentErrors: function () {
                this.showErrors = (this.currentErrors != null) && (this.currentErrors.length > 0);
            }
        },
        methods: {
            handleEnterKey: function (e) {
                if (this.isEventTargetWithinElement(e.event, this.$refs.inputFields)) {
                    this.insert();
                }
            },
            reset: function () {
                this.pageBreakBefore = false;
                this.pageBreakAfter = false;
                this.emptyLinesBefore = 0;
                this.emptyLinesAfter = 0;
                this.indented = false;
                this.currentErrors = null;
            },
            insert: function () {
                this.currentErrors = []
                if (this.currentErrors.length == 0) {
                    if (!this.sectionId) this.sectionId = newUuid();
                    var metaData = {
                        SectionId: this.sectionId,
                        Type: 'retainingstyle',
                        PageBreakBefore: this.pageBreakBefore,
                        PageBreakAfter: this.pageBreakAfter,
                        EmptyLinesBefore: parseInt(this.emptyLinesBefore),
                        EmptyLinesAfter: parseInt(this.emptyLinesAfter),
                        Indented: this.indented
                    }

                    var base64EncodedMetaData = btoa(JSON.stringify(metaData));
                    this.$emit('beforeSectionsInsertOrUpdate');
                    Vue.nextTick(() => {
                        if (this.mode == 'edit') {
                            $(this.currentEditorSection)
                                .attr('data-metadata', base64EncodedMetaData)
                                .data('metadata', base64EncodedMetaData); //IMPORTANT! we need to update both, the data-* attribute and the .data entry, because one is the actual HTML that is read by the server and one is the data that jquery stores internally
                            this.sectionUpdated = true;
                        } else {
                            var retainingStyleSection =
                                $('<div data-type="retainingstyle"/>')
                                    .attr('id', metaData.SectionId)
                                    .attr('data-metadata', base64EncodedMetaData)
                                    .insertAfter(this.currentEditorSection)[0];
                            var insertPosition = $('<p><br/></p>').appendTo(retainingStyleSection)[0];
                            this.sectionsInsertedEventData = { sections: [retainingStyleSection], insertPosition: insertPosition };
                        }
                        this.dialogOpen = false;
                    });
                }
            },
            onDialogHidden: function () {
                this.reset();
                this.$emit('change', false);
                if (this.sectionsInsertedEventData) {
                    this.$emit('sectionsInserted', this.sectionsInsertedEventData);
                } else if (this.sectionUpdated) {
                    this.$emit('sectionUpdated');
                } else {
                    this.$emit('cancelled');
                }
                this.sectionsInsertedEventData = null;
                this.sectionUpdated = false;
            }
        }
    }
</script>

